require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('views/generic.view.ts');

var Handlebars = require('handlebars');
var HandlebarsHelpers = require('../../../libs/handlebars/handlebars-helpers.ts');

var Template = require('text-loader!templates/checkin/availableQueues.template.html');

require('../../../libs/bootstrap/js/bootstrap-table.js');
var i18n = require("l10n");

var TheView = GenericView.extend({
    el: "#customerAvailableQueues",
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	initialize: function (options) {
		var self = this;

        this.multipleServices = options ? options.multipleServices : null;

        this.render();
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

        var templateData = {
            "multipleServices": this.multipleServices,
            "lang": i18n.lng()
        }

		this.$el.html(this.template(templateData));
console.log("rendered");
	},
	events: {
        "click .createTicketButton": "checkPatientIn"
	},
    loadAndGetAvailableQueues: function(customer) {
        var self = this;

        if(!customer) {
            this.multipleServices = null;
            this.render();
            this.show();
        }
        else {
            $.ajaxDefaultQ({
                url: "rest/api/multipleServices/customer?customerId=" + customer.id,
                type: 'GET',
            }).done(function(response, status, xhr){
                if(response && response.data) {
                    if(response.data.error) {
                        self.$el.notify(i18n.t("server.errorOccurred"),
                        {
                            position: "top center",
                            className: "error",
                            autoHide: true
                        });
                        self.multipleServices = null;
                    }
                    else {
                        self.multipleServices = response.data;
                    }

                }
                else {
                    self.multipleServices = null;
                    self.$el.notify(i18n.t("server.errorOccurred"),
                    {
                        position: "top center",
                        className: "error",
                        autoHide: true
                    });
                }

                self.render();
            })
            .fail(function(response) {
                self.$el.notify(i18n.t("server.errorOccurred"),
                {
                    position: "top center",
                    className: "error",
                    autoHide: true
                });
            });
        }
    },
    checkPatientIn: function(e) {
        var $elem = $(e.currentTarget);
        var id = $elem.data("id");

console.log("clicked");

        if(!id || isNaN(parseInt(id))) {
            $elem.notify(i18n.t("server.errorOccurred"),
            {
                position: "top center",
                className: "error",
                autoHide: true
            });
            return;
        }
        else {
            $.ajaxDefaultQ({
                url: "rest/api/multipleServices/checkIn?id=" + id,
                type: 'POST',
                contentType: "application/json"
            }).done(function(response, status, xhr){

                if(response != null) {
                    var text = "";
                    var className = "";

                    if(response.error != null) {
                        text = i18n.t("server.errorOccurred");
                        className = "error";
                    }
                    else if(response.data == "Success") {
                        text = i18n.t('counter.issuedTicketSuccess');
                        className = "success";
                    }
                    else if(response.data == "QueueClosed") {
                        text = i18n.t("counter.queueClosed");
                        className = "info";
                    }
                    else if(response.data == "CustomerDailyLimit") {
                        text = i18n.t("counter.customerDailyLimit");
                        className = "info";
                    }
                    else if(response.data == "QueueDailyLimit") {
                        text = i18n.t("counter.queueDailyLimit");
                        className = "info";
                    }
                    else if(response.data == "CustomerAlreadyHasTicket") {
                        text = i18n.t("counter.customerAlreadyHasTicket");
                        className = "info";
                    }
                    else {
                        text = i18n.t("server.errorOccurred");
                        className = "error";
                    }

                    $elem.notify(text,
                    {
                        position: "top center",
                        className: className,
                        autoHide: true
                    });

                }
                else {
                    $elem.notify(i18n.t("server.errorOccurred"),
                    {
                        position: "top center",
                        className: "error",
                        autoHide: true
                    });

                }
            })
            .fail(function(response) {
                $elem.notify(i18n.t("server.errorOccurred"),
                {
                    position: "top center",
                    className: "error",
                    autoHide: true
                });
            });
        }
    }
});

module.exports = TheView;